module.exports = __webpack_public_path__ + "static/img/change.04f6297f.svg";